import React from 'react';

export const ContactInfo = ({ title, text, phone, email, socialLinks }) => {

	const links = socialLinks.map(link => (
		<li key={link.link} className={link.platform}>
			<a href={link.link}>
				<span className={`fa fa-${link.platform}`} />
			</a>
		</li>
	));

	return (
		<div className="contact-info-column col-md-5 col-sm-12 col-xs-12">
			<div className="inner">
				<div className="sec-title style-two">
					<h2 dangerouslySetInnerHTML={{ __html: `${title}` }} />
				</div>
				<div className="text">
					<p>{text}</p>
					<div className="phone">{email}</div>
					<div className="phone">{phone}</div>
				</div>
				<div className="social-links">
					<ul className="clearfix">
						{links}
					</ul>
				</div>
			</div>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/Contact/ContactInfo.js